// ../../utilities/core/dist/index.mjs
var cast = (v) => v;

// src/use-machine.ts
import { useEffect, useLayoutEffect } from "react";
import { useSnapshot } from "valtio";

// src/use-constant.ts
import { useRef } from "react";
function useConstant(fn) {
  const ref = useRef();
  if (!ref.current) {
    ref.current = { v: fn() };
  }
  return ref.current.v;
}

// src/use-machine.ts
var useSafeLayoutEffect = typeof document !== "undefined" ? useLayoutEffect : useEffect;
function useService(machine, options) {
  const { actions, state: hydratedState, context } = options != null ? options : {};
  const service = useConstant(() => {
    const _machine = typeof machine === "function" ? machine() : machine;
    return context ? _machine.withContext(context) : _machine;
  });
  useSafeLayoutEffect(() => {
    service.start(hydratedState);
    return () => {
      service.stop();
    };
  }, []);
  useSafeLayoutEffect(() => {
    service.setActions(actions);
  }, [actions]);
  useSafeLayoutEffect(() => {
    if (!context)
      return;
    service.setContext(context);
  }, [context]);
  return service;
}
function useMachine(machine, options) {
  const service = useService(machine, options);
  const state = cast(useSnapshot(service.state, {
    sync: service.options.hookSync
  }));
  return [state, service.send, service];
}

// src/use-actor.ts
import { useSnapshot as useSnapshot2 } from "valtio";
function useActor(service) {
  const current = cast(useSnapshot2(service.state, {
    sync: service.options.hookSync
  }));
  return [current, service.send];
}

// src/use-setup.ts
import { useEffect as useEffect2, useRef as useRef2 } from "react";
function useSetup(props) {
  const { send, id } = props;
  const ref = useRef2(null);
  useEffect2(() => {
    if (!id)
      return;
    Promise.resolve().then(() => {
      const el = ref.current;
      const doc = el == null ? void 0 : el.ownerDocument;
      const root = el == null ? void 0 : el.getRootNode();
      send({ type: "SETUP", doc, root, id });
    });
  }, [id]);
  return ref;
}

// src/index.ts
import { mergeProps } from "@zag-js/core";
export {
  mergeProps,
  useActor,
  useMachine,
  useService,
  useSetup
};
//# sourceMappingURL=index.mjs.map
